var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrendingDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 13,
  fill: "none",
  viewBox: "0 0 20 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.6.5 20 1.9l-7.4 7.45-4-4-5.2 5.15H6v2H0v-6h2v2.6l6.6-6.6 4 4z"
})));
export { SvgTrendingDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAyMCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjYgMC41TDIwIDEuOUwxMi42IDkuMzVMOC42IDUuMzVMMy40IDEwLjVMNiAxMC41TDYgMTIuNUwwIDEyLjVMNS4yNDUzN2UtMDcgNi41TDIgNi41TDIgOS4xTDguNiAyLjVMMTIuNiA2LjVMMTguNiAwLjVaIiBmaWxsPSIjRkZGRkZGIi8+Cjwvc3ZnPgo=";